var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1167 8.18971C10.7498 6.7746 12.8391 5.99699 15 6.00001C19.9707 6.00001 24 10.0293 24 15C24 16.9224 23.397 18.7044 22.371 20.166L19.5 15H22.2C22.2001 13.5885 21.7853 12.208 21.0072 11.0303C20.2291 9.85264 19.1219 8.92965 17.8235 8.37612C16.525 7.82259 15.0924 7.66294 13.704 7.91702C12.3155 8.17111 11.0323 8.82772 10.014 9.80521L9.1167 8.18971ZM20.8833 21.8103C19.2502 23.2254 17.1609 24.003 15 24C10.0293 24 6 19.9707 6 15C6 13.0776 6.603 11.2956 7.629 9.83401L10.5 15H7.8C7.79988 16.4115 8.21467 17.792 8.9928 18.9697C9.77093 20.1474 10.8781 21.0704 12.1765 21.6239C13.475 22.1774 14.9075 22.3371 16.296 22.083C17.6845 21.8289 18.9677 21.1723 19.986 20.1948L20.8833 21.8103Z",
    fill: "#EDAD0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/icon_reload.7344198c889c0967c683b0aed5c5a17c.svg";
export { ForwardRef as ReactComponent };